import React from "react";

export interface SpecialistProfileTabsProps {
  tabs: string[];
  currentStep: number;
  /**
   * Optional: allow clicking on steps. If you want to prevent jumping ahead,
   * only call this for indices <= currentStep in the parent.
   */
  onStepClick?: (index: number) => void;
}

/**
 * Simple presentational stepper for the Specialist Profile wizard.
 * No business logic, no API calls.
 */
const SpecialistProfileTabs: React.FC<SpecialistProfileTabsProps> = ({
  tabs,
  currentStep,
  onStepClick,
}) => {
  return (
    <div style={{ marginBottom: 24 }}>
      <ol
        style={{
          display: "flex",
          listStyle: "none",
          padding: 0,
          margin: 0,
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        {tabs.map((label, index) => {
          const isActive = index === currentStep;
          const isComplete = index < currentStep;
          const isClickable = typeof onStepClick === "function";

          const baseStyles: React.CSSProperties = {
            padding: "8px 12px",
            borderRadius: 16,
            border: "1px solid #ccc",
            backgroundColor: isActive ? "#0017a2" : "#f5f5f5",
            color: isActive ? "#fff" : "#333",
            fontSize: 14,
            cursor: isClickable ? "pointer" : "default",
            display: "flex",
            alignItems: "center",
            gap: 6,
          };

          return (
            <li
              key={label}
              style={baseStyles}
              onClick={() => {
                if (!isClickable) return;
                onStepClick!(index);
              }}
            >
              <span
                style={{
                  minWidth: 20,
                  height: 20,
                  borderRadius: "50%",
                  border: "1px solid rgba(255, 255, 255, 0.6)",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  backgroundColor: isActive
                    ? "rgba(255,255,255,0.15)"
                    : isComplete
                    ? "#e0e0e0"
                    : "#ffffff",
                  color: isActive ? "#fff" : "#333",
                }}
              >
                {index + 1}
              </span>
              <span>{label}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default SpecialistProfileTabs;
